<div class="aws-marketplace-header" *ngIf="step === 'signup' || step === 'mispellEmail'">
    <span class="marketplace-logo"></span>
    <span> You are signing up for {{productTypeText}} from Alert Logic. To cancel or manage your subscription, you must do so through Amazon by selecting to <a [href]="awsUrl">manage your subscriptions</a></span>
</div>
<div class="signup-success-header" *ngIf="step === 'confirm'">
    <span> Your registration was successful. </span>
</div>
<div class="signup-error-header" *ngIf="step === 'awsTokenExpired'">
    <span> Your AWS registration token has expired. </span>
</div>
<div class="signup">
    <div class="wrap p-grid">
        <div class="p-col-12">
            <span class="logo"></span>
        </div>
        <p-card class="p-col-12 card">
            <div class="p-grid p-nogutter header">
                <div class="p-col-12">
                    <h2 class="title">{{title}}</h2>
                </div>
                <div class="p-col-12" *ngFor="let description of descriptions">
                    <p>{{ description }}</p>
                </div>
            </div>
            <br>
            <form *ngIf="step === 'signup' || step === 'confirm' || step === 'alreadyAccount'"
                  class="form"
                  [formGroup]="form"
                  (ngSubmit)="onSubmit()">
                <div *ngIf="form"
                     class="p-grid">
                    <div class="p-col-12" *ngIf="step === 'signup'">
                        <span class="md-inputfield">
                            <input type="text"
                                   pInputText
                                   formControlName="first_name" />
                            <label for="first_name">First name *</label>
                            <ng-container
                                          *ngTemplateOutlet="errorForm; context: { $implicit: { key: 'first_name', message: 'Please use english characters only'}}">
                            </ng-container>
                        </span>
    
                    </div>
                    <div class="p-col-12" *ngIf="step === 'signup'">
                        <span class="md-inputfield">
                            <input type="text"
                                   pInputText
                                   formControlName="last_name" />
                            <label for="last_name">Last name *</label>
                            <ng-container
                                          *ngTemplateOutlet="errorForm; context: { $implicit: { key: 'last_name', message: 'Please use english characters only'}}">
                            </ng-container>
                        </span>
                    </div>
                    <div class="p-col-12" *ngIf="step === 'signup' || step === 'confirm' || step === 'alreadyAccount'">
                        <span class="md-inputfield">
                            <input type="email"
                                   pInputText
                                   [readonly]="step === 'confirm' || step === 'alreadyAccount'"
                                   formControlName="user_email" />
                            <label for="email">Email *</label>
                            <ng-container *ngTemplateOutlet="errorForm; context: { $implicit: { key: 'user_email' }}">
                            </ng-container>
                        </span>
                    </div>
                    <div class="p-col-12" *ngIf="step === 'signup'">
                        <span class="md-inputfield">
                            <input type="text"
                                   pInputText
                                   formControlName="account_name" />
                            <label for="account_name">Company *</label>
                            <ng-container
                                          *ngTemplateOutlet="errorForm; context: { $implicit: { key: 'account_name', message: 'Please use english characters only'}}">
                            </ng-container>
                        </span>
                    </div>
                    <div class="p-col-12" *ngIf="step === 'signup'">
                        <span class="md-inputfield">
                            <input type="tel"
                                   pInputText
                                   formControlName="phone_number" />
                            <label for="phone_number">Phone</label>
                            <ng-container
                                          *ngTemplateOutlet="errorForm; context: { $implicit: { key: 'phone_number', message: 'The phone number is invalid. Format examples:  (999) 999-9999 +1999.999.9999'}}">
                            </ng-container>
                        </span>
                    </div>
                    <div class="p-col-12 text-align-center" *ngIf="step === 'signup'">
                        <p-button styleClass="primaryAction"
                                  [icon]="loading ? 'pi pi-spin pi-spinner' : ''"
                                  label="Sign Up"
                                  [disabled]="!form || form.invalid">
                        </p-button>
                    </div>
                </div>
            </form>
            <div class="p-grid p-nogutter text-align-center" *ngIf="showMispelledEmail">
                <div class="p-col-12">
                    <a href="javascript: void(0)" (click)="showMispelledEmailInformation()"><span>Oops, I mispelled my email address!</span></a>
                </div>
            </div>
            <div class="p-grid text-align-center"
                 *ngIf="actions">
                <div class="p-col-12" *ngFor="let action of actions">
                    <p-button styleClass="primaryAction"
                              [label]="action.label"
                              (click)="executeAction(action.event)">
                    </p-button>
                </div>
            </div>
        </p-card>
        <al-view-helper></al-view-helper>

    </div>
</div>
<ng-template #errorForm
             let-element>
    <div *ngIf="element && form?.controls[element.key].invalid && (form?.controls[element.key]?.dirty || form?.controls[element.key]?.touched)"
         class="ui-message ui-messages-error ui-corner-all">
        <div *ngIf="form?.controls[element.key].errors?.required">
            This field is required.
        </div>
        <div *ngIf="form.controls[element.key].errors?.pattern">
            {{element.message}}
        </div>
        <div *ngIf="form.controls[element.key].errors?.email">
            Invalid email address.
        </div>
    </div>
</ng-template>